import { createContext, useContext } from "react";

/**
 * Whether a menu row that has no icon still reserves the space one would take.
 *
 * On by default, and that default is load-bearing: in a menu where only some
 * rows carry an icon it is the only thing keeping every label on one left
 * edge. The cost is a menu whose rows never carry an icon — a list of names,
 * say — where the column is 22px of nothing and the labels hang to the right
 * of their own group headers. Those menus turn it off.
 *
 * Unset means inherit, so a submenu keeps whatever its parent decided.
 */
const MenuIconColumnContext = createContext(true);

export function useMenuIconColumn(): boolean {
  return useContext(MenuIconColumnContext);
}

export { MenuIconColumnContext };
